// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";

function Icon(props) {
  let __shouldMirrorIcon = props.shouldMirrorIcon;
  let __style = props.style;
  let __iconType = props.iconType;
  let className = props.className;
  let __width = props.width;
  let __size = props.size;
  let __size_value = __size !== undefined ? __size : 20;
  let __width_value = __width !== undefined ? __width : __size_value;
  let __iconType_value = __iconType !== undefined ? __iconType : "orca";
  let __style_value = __style !== undefined ? __style : ({});
  let __shouldMirrorIcon_value = __shouldMirrorIcon !== undefined ? __shouldMirrorIcon : false;
  let otherClasses = className !== undefined ? className : "";
  return JsxRuntime.jsx("svg", {
    children: JsxRuntime.jsx("use", {
      xlinkHref: publicPath + `/icons/` + __iconType_value + `.svg#` + props.name
    }),
    className: `fill-current ` + otherClasses,
    style: __style_value,
    height: __size_value.toString() + "px",
    width: __width_value.toString() + "px",
    onClick: props.onClick,
    transform: __shouldMirrorIcon_value ? "scale(-1,1)" : ""
  });
}

let make = Icon;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
